<template>
    <div>
        <div class="aFlex fchart-box-top">
            <span class="ft-bold">工资发放情况</span>
            <span class="ft-gray" style="margin-left: 10px">默认统计系统日期上个月</span>
        </div>
        <div class="fchart-bi" ref="payoffPie">工资发放情况</div>
    </div>
</template>

<script>
    export default {
        name: "payoffPie",
        data() {
            return {
                // 工资发放
                payoffPie:null,
            }
        },
        props: {
            areaCode:{
                type: [String,Number]
            },
            dateMonth:{
                type: [String,Number]
            },
        },
        mounted() {
            //引入echarts 初始化图标
            let echarts = require('echarts');
            // 工资发放情况
            this.payoffPie = echarts.init(this.$refs.payoffPie);
            //初始化 setOption
            this.initChart();
            //获取数据
            this.getData();
            window.addEventListener('resize',this.resize);
            window.addEventListener('load',this.resize);
            /*加载完成自适应*/
            this.$nextTick( ()=> {
                this.resize();
            });
        },
        methods: {
            // echarts 适应
            resize(){
                this.payoffPie.resize();
            },
            initChart(){
                this.payoffPie.setOption(
                    {
                        title:{
                            textStyle:{
                                color: '#999999',
                                fontSize:13,
                                fontWeight:400
                            },
                            textAlign:'center',
                            right:'10%',
                            bottom: 15,
                            text: '项目总数',
                        },
                        legend: {
                            orient: 'horizontal',
                            bottom:15,
                            right:'40%',
                            icon:'circle',
                        },
                        tooltip: {
                            trigger: 'item',
                            formatter: '{b} : {c} ({d}%)'
                        },
                        color:[ '#3399FF','#61DDAA','#65789B','#F6BD16'],
                        series: [
                            {
                                type: 'pie',
                                center: ['50%', '43%'],
                                radius:['40%', '65%'],
                                label:{
                                    show:true,
                                    formatter:(params)=>{
                                        return `${params.name}: ${params.percent}%`
                                    }
                                },
                                itemStyle: { //图形样式
                                    normal: {
                                        borderColor: '#ffffff',
                                        borderWidth: 2,
                                    },
                                },
                                data:[]
                            }
                        ]
                    }
                );
            },
            // 工资发放情况统计 饼状图
            getData(){
                this.payoffPie.showLoading();
                this.axios({
                    method: 'post',
                    url: '/summary/querySummaryPayOffCount',
                    data:{
                        areaCode:this.areaCode,
                        date:this.dateMonth,
                    }
                }).then( (response)=> {
                    this.payoffPie.hideLoading();
                    if (response.data){
                        response.data.length && this.payoffPie.setOption(
                            {
                                title:{
                                    text: '项目总数: '+ response.data[2].value +'个',
                                },
                                legend:{
                                    // 使用回调函数
                                    formatter: function (name) {
                                        let val=response.data.filter(item=>{
                                            return item.name===name;
                                        })[0].value || 0;
                                        return name + val;
                                    }
                                },
                                series: [
                                    {
                                        data:response.data.slice(0,2)
                                    }
                                ]
                            }
                        );
                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>
